angular.module("registrationModule").component("registrationPasswordResetConfirmation", {
	templateUrl: "registrationPasswordResetConfirmation/registrationPasswordResetConfirmation.html",
	bindings: {
		adDesignEnabled: "<",
		onSubmit: "&",
		onClose: "&"
	},
	controller: ["$document", "$timeout", "$element", function($document, $timeout, $element) {
		var self = this;

		this.submit = function() {
			this.onSubmit();
		};

		this.$onDestroy = function() {
			$document.off("click", self.closeHandler);
		};

		this.closeHandler = function(e) {
			if ($element !== e.target && !$element[0].contains(e.target)) {
				$timeout(function () { self.onClose();});
			}
		};

		this.fieldChange = function(key) {
			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + "Exist", true);
				this.form[key].$setValidity(key + "Short", true);
				this.form[key].$setValidity(key + "Global", true);
			}

			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
			this.form.needsValidation = true;
		};
	}]
});
